import * as React from 'react';
import { SVGProps } from 'react';

const IconSmileFilledSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 10A5 5 0 1 0 5 0a5 5 0 0 0 0 10Zm1.734-3.976A2.01 2.01 0 0 1 3.34 6l-.84.525a3 3 0 0 0 5.066.035l-.832-.536ZM3 4h1v1H3V4Zm4 0H6v1h1V4Z"
    />
  </svg>
);
export default IconSmileFilledSizeXs;
